export const DL_UPDATE_STATE = "DL_UPDATE_STATE"
export const DL_MAKE_SOCKET_CONNECTION = "DL_MAKE_SOCKET_CONNECTION"
export const DL_CALL_SOCKET_METHOD = "DL_CALL_SOCKET_METHOD"
export const DL_SOCKET_DISCONNECT = "DL_SOCKET_DISCONNECT"
export const DL_EMIT_CUSTOM_EVENT = "DL_EMIT_CUSTOM_EVENT"
export const DL_ADD_MESSAGE = "DL_ADD_MESSAGE"
export const DL_UPDATE_MESSAGE = "DL_UPDATE_MESSAGE"
export const DL_DELETE_MESSAGE = "DL_DELETE_MESSAGE"
